interface Testimonial {
  content: string;
  author: string;
  position: string;
}

interface CaseTestimonialProps {
  testimonial: Testimonial;
}

export default function CaseTestimonial({ testimonial }: CaseTestimonialProps) {
  const isHtml = testimonial.content?.trim().startsWith('<');
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-12">
          <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-8">
            <i className="ri-double-quotes-l text-3xl text-white"></i>
          </div>
          {isHtml ? (
            <div
              className="text-xl text-gray-800 leading-relaxed text-center mb-8 italic prose prose-lg max-w-none"
              dangerouslySetInnerHTML={{ __html: testimonial.content }}
            />
          ) : (
            <p className="text-xl text-gray-800 leading-relaxed text-center mb-8 italic">
              &ldquo;{testimonial.content}&rdquo;
            </p>
          )}
          <div className="text-center">
            <div className="font-bold text-gray-900 text-lg">{testimonial.author}</div>
            <div className="text-gray-600">{testimonial.position}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
